import { render, staticRenderFns } from "./itemsComponent.vue?vue&type=template&id=12f620bb&scoped=true&"
import script from "./itemsComponent.vue?vue&type=script&lang=js&"
export * from "./itemsComponent.vue?vue&type=script&lang=js&"
import style0 from "./itemsComponent.vue?vue&type=style&index=0&id=12f620bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f620bb",
  null
  
)

export default component.exports